function initSharer() {
	document.querySelectorAll('.copy-sharer').forEach((el) => {
		el.addEventListener('click', function () {
			navigator.clipboard.writeText(this.dataset.url);
			const text = this.innerHTML;
			this.innerHTML = this.dataset.copyText;
			setTimeout(() => {
				this.innerHTML = text;
			}, 1500);
		});
	})
}
